import React from "react";

const Footer = () => {
  return (
    <div className="container">
      <hr />
      <div className="row py-3" align="center">
        <p className="col-md-12">
          <strong>
            © 2021-23 AiEnsured - All Rights Reserved <br />
            Testaing Solutions Private Ltd.{" "}
          </strong>
        </p>
      </div>
    </div>
  );
};

export default Footer;
